var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HorizonJs_Uuid } from "horizon-js-sdk/lib/HorizonJs_Uuid";
import Model from "../Model";
import GroupItem from "../Product/GroupItem";
import Product from "../Product/Product";
import { PurchaseItem } from "./PurchaseItem";
var Purchase = /** @class */ (function (_super) {
    __extends(Purchase, _super);
    /**
     * Construct a product from a javascript object of a json string
     * @param obj either a javascript object or a json string
     */
    function Purchase(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.productUid = null;
        _this.itemUid = null;
        _this.price = 0;
        _this.priceWithTax = 0;
        _this.feesFixed = 0;
        _this.feesPercent = 0;
        _this.childPurchases = [];
        _this.items = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Purchase.buildFromJson(_this, obj);
        return _this;
    }
    Purchase.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'childPurchases') {
                        for (var i in json[prop]) {
                            if (json[prop].hasOwnProperty(i)) {
                                instance.childPurchases.push(new Purchase(json[prop][i]));
                            }
                        }
                    }
                    else if (prop === 'price' || prop === 'priceWithTax' || prop === 'feesFixed' || prop === 'feesPercent' || prop === 'vat') {
                        instance[prop] = json[prop];
                    }
                    else if (prop === 'items') {
                        for (var i in json[prop]) {
                            if (json[prop].hasOwnProperty(i)) {
                                instance.items.push(new PurchaseItem(json[prop][i]));
                            }
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Purchase.prototype.exportToJson = function (withVat) {
        if (withVat === void 0) { withVat = false; }
        var JSONPurchase = {};
        JSONPurchase.uid = this.uid;
        JSONPurchase.name = this.name;
        JSONPurchase.productUid = this.productUid;
        JSONPurchase.itemUid = this.itemUid;
        JSONPurchase.creationDate = this.creationDate;
        // JSONOrder.paymentDate= this.paymentDate;
        // JSONOrder.invoiceUid= this.invoiceUid;
        // JSONOrder.invoiceFeesUid= this.invoiceFeesUid;
        JSONPurchase.feesFixed = this.feesFixed;
        JSONPurchase.feesPercent = this.feesPercent;
        JSONPurchase.childPurchases = [];
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var item = _a[_i];
            JSONPurchase.childPurchases.push(item.exportToJson());
        }
        JSONPurchase.items = [];
        for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
            var item = _c[_b];
            JSONPurchase.items.push(item.exportToJson());
        }
        // JSONPurchase.price = this.price;
        JSONPurchase.price = null;
        JSONPurchase.priceWithTax = this.priceWithTax;
        JSONPurchase.vat = this.vat;
        // JSONOrder.totalPrice= this.totalPrice;
        // JSONOrder.totalPriceWithTax= this.totalPriceWithTax;
        // JSONOrder.fees= this.fees;
        // JSONOrder.feesFixed= this.feesFixed;
        // JSONOrder.feesPercent= this.feesPercent;
        // JSONOrder.status= this.status;
        // JSONOrder.hasTicket= this.hasTicket;
        // JSONOrder.billingAddress= this.billingAddress;
        JSONPurchase.contextVariableUid = this.contextVariableUid;
        return JSONPurchase;
    };
    Purchase.prototype.generateUid = function (allChilds) {
        if (allChilds === void 0) { allChilds = false; }
        if (this.uid === null) {
            this.uid = HorizonJs_Uuid.v4();
        }
        if (allChilds) {
            for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
                var purchase = _a[_i];
                purchase.generateUid(allChilds);
            }
            for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
                var item = _c[_b];
                item.generateUid(allChilds);
            }
        }
    };
    Purchase.prototype.search_uid = function (uid) {
        if (this.uid === uid) {
            return this;
        }
        else {
            for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
                var p = _a[_i];
                var current_search = p.search_uid(uid);
                if (p.search_uid(uid) !== null) {
                    return current_search;
                }
            }
            for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
                var i = _c[_b];
                var current_search = i.search_uid(uid);
                if (i.search_uid(uid) !== null) {
                    return current_search;
                }
            }
        }
        return null;
    };
    Purchase.prototype.is_same_status_as_current = function (statusUid) {
        if (this.items.length === 0 && this.childPurchases.length === 0) {
            return { isOk: false };
        }
        var is_same = { isOk: true };
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            is_same = item.is_same_status_as_current(statusUid);
            if (!is_same.isOk) {
                return is_same;
            }
        }
        for (var _b = 0, _c = this.childPurchases; _b < _c.length; _b++) {
            var purchase = _c[_b];
            is_same = purchase.is_same_status_as_current(statusUid);
            if (!is_same.isOk) {
                return is_same;
            }
        }
        return is_same;
    };
    Purchase.prototype.is_status_allowed = function (statusUid, options) {
        if (this.items.length > 0) {
            var is_next_status_authorized = { isOk: true };
            /** Tester si les items acceptent le status actuel **/
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                is_next_status_authorized = item.is_status_allowed(statusUid, {
                    flow: options.flow,
                    initialStatus: options.initialStatus,
                    debug: options.debug
                });
                if (!is_next_status_authorized.isOk) {
                    if (options.debug) {
                        console.warn("Refused");
                    }
                    if (is_next_status_authorized.reason === undefined) {
                        is_next_status_authorized.reason = [];
                    }
                    if (this.itemUid !== null) {
                        is_next_status_authorized.reason.unshift({
                            reason: "Status refusé",
                            itemUid: this.itemUid,
                            statusUid: statusUid,
                        });
                    }
                    else if (this.productUid !== null) {
                        is_next_status_authorized.reason.unshift({
                            reason: "Status refusé",
                            productUid: this.productUid,
                            statusUid: statusUid
                        });
                    }
                    return is_next_status_authorized;
                }
            }
            /** Si besoin : on regarde les enfants acceptes également **/
            if (is_next_status_authorized.isOk && options && options.allChilds) {
                for (var _b = 0, _c = this.childPurchases; _b < _c.length; _b++) {
                    var purchase = _c[_b];
                    is_next_status_authorized = purchase.is_status_allowed(statusUid, {
                        allChilds: options.allChilds,
                        flow: options.flow,
                        initialStatus: options.initialStatus,
                    });
                    if (!is_next_status_authorized.isOk) {
                        if (is_next_status_authorized.reason === undefined) {
                            is_next_status_authorized.reason = [];
                        }
                        if (this.itemUid !== null) {
                            is_next_status_authorized.reason.unshift({
                                reason: "Status refusé dans les enfants",
                                itemUid: this.itemUid,
                                statusUid: statusUid
                            });
                        }
                        else if (this.productUid !== null) {
                            is_next_status_authorized.reason.unshift({
                                reason: "Status refusé dans les enfants",
                                productUid: this.productUid,
                                statusUid: statusUid
                            });
                        }
                        return is_next_status_authorized;
                    }
                }
            }
            if (is_next_status_authorized.isOk) {
                return is_next_status_authorized;
            }
        }
        if (this.productUid !== null) {
            return {
                isOk: false, reason: [{
                        productUid: this.productUid,
                        reason: "Item length === 0",
                        statusUid: statusUid
                    }]
            };
        }
        else if (this.itemUid !== null) {
            return { isOk: false, reason: [{ itemUid: this.itemUid, reason: "Item length === 0", statusUid: statusUid }] };
        }
        return { isOk: false, reason: [{ reason: "Inconnue dans Purchase.ts", statusUid: statusUid }] };
    };
    //TODO : ajouter le fait de pouvoir ne pas vérifier certains status ex.: Status annulé, ca fait actuellement du conflit.
    Purchase.prototype.add_status = function (statusUid, options) {
        if (this.items.length > 0) {
            /** Test : Est ce que l'ajout est autorisé **/
            var is_next_status_authorized = this.is_status_allowed(statusUid, options);
            /** Si oui : on continue **/
            if (is_next_status_authorized.isOk) {
                /** On ajoute aux enfants si c'est nécessaire **/
                if (options && options.allChilds) {
                    for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
                        var purchase = _a[_i];
                        if (options.productOrGroupItem) {
                            var groupItem = null;
                            if (purchase.itemUid) {
                                var item = options.productOrGroupItem.getGroupItem(purchase.itemUid);
                                if (item) {
                                    groupItem = item.groupItem;
                                }
                            }
                            if (groupItem === null) {
                                // Si pas de productOrGroupItem impossile d'executer
                                // les actions et risque d'avoir un stock désynchronisé
                                return {
                                    isOk: false,
                                    reason: [{
                                            reason: "Null productOrGroupItem, could lead to inconsistencies",
                                            statusUid: statusUid
                                        }]
                                };
                            }
                            purchase.add_status(statusUid, {
                                allChilds: options.allChilds,
                                flow: options.flow,
                                products: options.products,
                                productOrGroupItem: groupItem,
                                initialStatus: options.initialStatus,
                                debug: options.debug,
                                dryRun: options.dryRun
                            });
                        }
                        else {
                            // Si pas de productOrGroupItem impossile d'executer
                            // les actions et risque d'avoir un stock désynchronisé
                            return {
                                isOk: false,
                                reason: [{
                                        reason: "Null productOrGroupItem, could lead to inconsistencies",
                                        statusUid: statusUid
                                    }]
                            };
                        }
                    }
                }
                /** On ajoute aux items et
                 * on lui passe le bon groupItem **/
                for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
                    var item = _c[_b];
                    item.add_status(statusUid, {
                        flow: options.flow,
                        productOrGroupItem: options.productOrGroupItem,
                        initialStatus: options.initialStatus,
                        products: options.products,
                        debug: options.debug,
                        dryRun: options.dryRun
                    });
                }
                return { isOk: true };
            }
            else {
                if (options.debug) {
                    console.warn("Le status n'est pas autorisé.\n", "File : Purchase.ts\n", "Object : Purchase\n", "Function : add_status()\n", "ProductUid : " + this.productUid + "\n", "ItemUid : " + this.itemUid + "\n");
                }
                return is_next_status_authorized;
            }
        }
        else {
            /** Les erreurs possibles **/
            if (this.productUid !== null) {
                return {
                    isOk: false, reason: [{
                            productUid: this.productUid,
                            reason: "Item length === 0",
                            statusUid: statusUid
                        }]
                };
            }
            else if (this.itemUid !== null) {
                return {
                    isOk: false,
                    reason: [{ itemUid: this.itemUid, reason: "Item length === 0", statusUid: statusUid }]
                };
            }
        }
        return { isOk: false, reason: [{ reason: "Inconnue dans Purchase.ts", statusUid: statusUid }] };
    };
    Purchase.prototype.haveStatus = function (statusUids) {
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            var itemHaveStatus = false;
            for (var _b = 0, _c = item.statuses; _b < _c.length; _b++) {
                var status_1 = _c[_b];
                for (var _d = 0, statusUids_1 = statusUids; _d < statusUids_1.length; _d++) {
                    var statusUid = statusUids_1[_d];
                    if (status_1.statusUid === statusUid) {
                        itemHaveStatus = true;
                        break;
                    }
                }
            }
            if (!itemHaveStatus) {
                return false;
            }
        }
        for (var _e = 0, _f = this.childPurchases; _e < _f.length; _e++) {
            var purchase = _f[_e];
            var have = purchase.haveStatus(statusUids);
            if (!have)
                return false;
        }
        return true;
    };
    Purchase.prototype.getPriceWithTax = function (status_canceled, params) {
        if (params === void 0) { params = null; }
        function getPriceOfPurchase(purchase) {
            var priceWithTax = 0;
            priceWithTax += purchase.priceWithTax * purchase.get_sum_items(status_canceled);
            for (var _i = 0, _a = purchase.childPurchases; _i < _a.length; _i++) {
                var childPurchase = _a[_i];
                priceWithTax += getPriceOfPurchase(childPurchase);
            }
            return priceWithTax;
        }
        var priceWithTax = 0;
        var unitPriceWithTax = this.priceWithTax;
        /** Par défault le purchase a le prix avec le contexte
         * Si l'on osuhaite obtenir l'ancien prix, dans ce cas il faut retrouver le produit originel
         * et récupérer son prix **/
        if (params && params.withoutContext && params.products) {
            var product = this.findProduct(params.products);
            if (product) {
                unitPriceWithTax = product.priceWithTax;
            }
        }
        else if (params && params.withoutContext && !params.products) {
            console.warn("On veut le prix sans le context mais on ne donne pas la liste des produits ?", "File : Purchase.ts", "Object : Purchase", "Function : getPriceWithTax()");
        }
        priceWithTax += unitPriceWithTax * this.get_sum_items(status_canceled);
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            //TODO : passer le groupItem qu'il faut
            //Ce cas sera uniquement à gérer quand il y aura un OvercostWithTax
            priceWithTax += getPriceOfPurchase(purchase);
        }
        return priceWithTax;
    };
    Purchase.prototype.findProduct = function (products) {
        for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
            var product = products_1[_i];
            if (this.productUid === product.uid) {
                return product;
            }
        }
        return null;
    };
    Purchase.prototype.getAmountOfVAT = function (vat, status_canceled) {
        var totalVAT = 0;
        if (this.vat === vat) {
            totalVAT += (this.priceWithTax - this.price) * this.get_sum_items(status_canceled);
        }
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var child = _a[_i];
            totalVAT += child.getAmountOfVAT(vat, status_canceled);
        }
        return totalVAT;
    };
    Purchase.prototype.getQuantityByLevel = function (currentLevel, status_canceled, quantityByLevel) {
        if (currentLevel === void 0) { currentLevel = 0; }
        if (quantityByLevel === void 0) { quantityByLevel = {}; }
        if (quantityByLevel[currentLevel] === undefined) {
            quantityByLevel[currentLevel] = 0;
        }
        quantityByLevel[currentLevel] += this.get_sum_items(status_canceled);
        if (this.childPurchases.length > 0) {
            quantityByLevel[currentLevel + 1] = 0;
        }
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var item = _a[_i];
            item.getQuantityByLevel(currentLevel + 1, status_canceled, quantityByLevel);
        }
        return quantityByLevel;
    };
    Purchase.prototype.getPurchase = function (purchaseUid) {
        if (this.uid === purchaseUid)
            return this;
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            var p = purchase.getPurchase(purchaseUid);
            if (p !== null) {
                return p;
            }
        }
        return null;
    };
    Purchase.prototype.getPurchase_and_parentPurchase = function (purchaseUid) {
        if (this.uid === purchaseUid)
            return { purchase: this, parentPurchase: null };
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            var p_and_pp = purchase.getPurchase_and_parentPurchase(purchaseUid);
            if (p_and_pp !== null) {
                if (p_and_pp.parentPurchase === null) {
                    p_and_pp.parentPurchase = this;
                }
                return p_and_pp;
            }
        }
        return null;
    };
    /**
     * Pour le moment on ajoute une quantité sur la purchase Item.
     * Car le produit est indénombrable (pas de référence unique)
     * **/
    //TODO : Produit dénombrable avec référence unique.
    Purchase.prototype.add_product = function (params) {
        var product = params.product;
        if ((!product.quantitySelector.isProductUniquable && product.groups.length === 0) || product.quantitySelector.isProductUniquable) {
            if (product.uid === this.productUid || this.productUid === null) {
                /** Ajouter les item du purchase
                 * Pour le moment : indénombrable.
                 * **/
                var isAddItemAllowed = this.add_purchaseItem({
                    productOrGroupItem: product,
                    quantity: params.quantity,
                    replaceOrAdd: params.replaceOrAdd,
                    statusCanceled: params.statusCanceled,
                    debug: params.debug,
                    currentContext: params.currentContext
                });
                if (isAddItemAllowed) {
                    this.productUid = product.uid;
                    this.name = product.name;
                    /** Prix **/
                    if (!params.currentContext) {
                        this.price = product.price;
                        this.priceWithTax = product.priceWithTax;
                        this.vat = product.vat;
                    }
                    else {
                        if (Array.isArray(params.currentContext)) {
                            for (var _i = 0, _a = params.currentContext; _i < _a.length; _i++) {
                                var context_1 = _a[_i];
                                if (context_1.productUid === params.product.uid) {
                                    this.price = context_1.price;
                                    this.priceWithTax = context_1.priceWithTax;
                                    this.vat = context_1.vat;
                                    this.contextVariableUid = context_1.contextVariableUid;
                                }
                            }
                        }
                        else {
                            if (params.currentContext.productUid === params.product.uid) {
                                this.price = params.currentContext.price;
                                this.priceWithTax = params.currentContext.priceWithTax;
                                this.vat = params.currentContext.vat;
                                this.contextVariableUid = params.currentContext.contextVariableUid;
                            }
                        }
                    }
                    /**
                     * Recurcivité pour les enfants.
                     * **/
                    var is_group_is_ok = this.add_groups({
                        groups: product.groups,
                        quantity: params.quantity,
                        replaceOrAdd: params.replaceOrAdd,
                        statusCanceled: params.statusCanceled,
                        debug: params.debug,
                        currentContext: params.currentContext
                    });
                    if (is_group_is_ok) {
                        return this;
                    }
                }
            }
            else {
                console.warn("L'UID du produit ne match pas.", "File : Purchase.ts", "Object : Purchase", "Function : add_product()");
            }
        }
        else {
            console.warn("Le produit n'est pas correct, incohérence entre UNIQUABLE et ses enfants.", "File : Purchase.ts", "Object : Purchase", "Function : add_product()");
        }
        return null;
    };
    Purchase.prototype.add_groups = function (params) {
        /**
         * Actuellement on test d'ajouter chaque GroupItem avec sa quantité minimal (si elle n'est pas indiquée.
         * Si cela ne fonctionne pas, on refuse.
         * C'est tout ou rien.
         * **/
        var groups = params.groups;
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            for (var _a = 0, _b = group.groupItems; _a < _b.length; _a++) {
                var groupItem = _b[_a];
                var childPurchase_in_purchase = this.found_childPurchase(groupItem);
                var found = true;
                //Si aucun enfant ne correspond à cet item, on en créé un.
                if (childPurchase_in_purchase === null) {
                    childPurchase_in_purchase = new Purchase();
                    found = false;
                }
                //On lui associe ce groupItem
                var is_addGroupItem_isAllowed = childPurchase_in_purchase.add_groupItem({
                    groupItem: groupItem,
                    quantity: params.quantity,
                    replaceOrAdd: params.replaceOrAdd,
                    statusCanceled: params.statusCanceled,
                    debug: params.debug,
                    currentContext: params.currentContext
                });
                if (is_addGroupItem_isAllowed && !found) {
                    this.childPurchases.push(childPurchase_in_purchase);
                }
                else {
                    return false;
                }
            }
        }
        return true;
    };
    Purchase.prototype.add_groupItem = function (params) {
        /** Si on essait de rien ajouter, on refuse **/
        if (params.quantity && params.quantity < 1) {
            return false;
        }
        /** Si un des purchaseItem est canceled, on refuse **/
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            for (var _b = 0, _c = item.statuses; _b < _c.length; _b++) {
                var status_2 = _c[_b];
                if (status_2.statusUid === params.statusCanceled) {
                    return false;
                }
            }
        }
        var groupItem = params.groupItem;
        if ((groupItem.productUid === this.productUid && groupItem.uid === this.itemUid)
            || (this.productUid === null && this.itemUid === null)) {
            var isAddItemAllowed = this.add_purchaseItem({
                productOrGroupItem: groupItem,
                replaceOrAdd: params.replaceOrAdd,
                statusCanceled: params.statusCanceled,
                debug: params.debug,
                quantity: params.quantity,
                currentContext: params.currentContext
            });
            if (isAddItemAllowed) {
                this.productUid = groupItem.productUid;
                this.itemUid = groupItem.uid;
                /** Price **/
                this.price = groupItem.overCost;
                this.priceWithTax = groupItem.overCostWithTax;
                /**
                 * Recurcivité pour les enfants.
                 * **/
                this.add_groups({
                    groups: groupItem.groups,
                    quantity: params.quantity,
                    replaceOrAdd: params.replaceOrAdd,
                    statusCanceled: params.statusCanceled,
                    currentContext: params.currentContext
                });
                return true;
            }
        }
        else {
            console.warn("L'UID du produit ne match pas.", "File : Purchase.ts", "Object : Purchase", "Function : add_groupItem()");
        }
        return false;
    };
    /** Cherche un groupee item, dans le niveau d'en dessous uniquement **/
    Purchase.prototype.found_childPurchase = function (groupItem) {
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            if (purchase.productUid === groupItem.productUid &&
                purchase.itemUid === groupItem.uid) {
                return purchase;
            }
        }
        return null;
    };
    Purchase.prototype.add_purchaseItem = function (params) {
        var quantity = null;
        if (params.quantity) {
            quantity = params.quantity;
        }
        var is_quantity_allowed_to_add = false;
        var productOrGroupItem = params.productOrGroupItem;
        if (params && params.productOrGroupItem) {
            var quantitySelector = productOrGroupItem.quantitySelector;
            if (params && params.currentContext) {
                if (Array.isArray(params.currentContext)) {
                    for (var _i = 0, _a = params.currentContext; _i < _a.length; _i++) {
                        var context_2 = _a[_i];
                        if (context_2.productUid === productOrGroupItem.uid) {
                            quantitySelector = context_2.quantitySelector;
                            this.contextVariableUid = context_2.contextVariableUid;
                        }
                    }
                }
                else {
                    if (params.currentContext.productUid === productOrGroupItem.uid) {
                        quantitySelector = params.currentContext.quantitySelector;
                        this.contextVariableUid = params.currentContext.contextVariableUid;
                    }
                }
            }
            if (quantity === null) {
                if (params.replaceOrAdd === "ADD") {
                    /** Si ce n'est pas précisé ajoute la plus petite valeur possible **/
                    quantity = quantitySelector.get_next_quantity(this.get_sum_items(params.statusCanceled)) - this.get_sum_items(params.statusCanceled);
                }
                else if (params.replaceOrAdd === "REPLACE") {
                    /** Si ce n'est pas précisé on écrase par la plus petite valeur **/
                    quantity = quantitySelector.minQuantity;
                }
                else {
                    return false;
                }
            }
            if (quantity !== null) {
                if (params.replaceOrAdd === "ADD") {
                    is_quantity_allowed_to_add = quantitySelector.is_quantity_allowed(this.get_sum_items(params.statusCanceled) + quantity, params.debug);
                }
                else if (params.replaceOrAdd === "REPLACE") {
                    is_quantity_allowed_to_add = quantitySelector.is_quantity_allowed(quantity, params.debug);
                }
            }
            else {
                console.warn("Quantité à ajouter, est null.\n", "Code : 2045\n", "File : Purchase.ts\n", "Object : Purchase\n", "Function : private add_purchaseItem()\n");
                console.group("Object en cours");
                console.warn(this);
                console.groupEnd();
                return false;
            }
            if (is_quantity_allowed_to_add) {
                /**Combien on en ajoute ?**/
                var how_many_items_to_add = 0;
                if (params.replaceOrAdd === "ADD") {
                    how_many_items_to_add = quantity;
                }
                else if (params.replaceOrAdd === "REPLACE") {
                    how_many_items_to_add = quantity - this.get_sum_items(params.statusCanceled);
                }
                /**On a juste à ajouter par la suite, le calcul a déjà été fait**/
                if (params.productOrGroupItem.quantitySelector.isProductUniquable) {
                    /** Dans le cas où c'est UNIQUE **/
                    if (how_many_items_to_add > 1) {
                        if (params.debug) {
                            console.warn("Quantité supérieure à un sur poruduct uniquable\n", "Code : 716\n", "File : Purchase.ts\n", "Object : Purchase\n", "Function : private add_purchaseItem()\n");
                        }
                        return false;
                    }
                    while (how_many_items_to_add > 0) {
                        var item = new PurchaseItem();
                        item.quantity = 1;
                        this.items.push(item);
                        how_many_items_to_add--;
                    }
                    this.update_price_of_purchase(params.productOrGroupItem);
                    return true;
                }
                else {
                    /** Dans le cas où c'est PAS UNIQUE **/
                    if (this.items.length > 1) {
                        /** En indénombrable on est censé avoir un seul item
                         * On pourrait optimiser pour les items qui sont annulés.
                         * **/
                        console.warn("item.length>1 : Weird.");
                    }
                    else {
                        if (this.items.length === 0) {
                            var item = new PurchaseItem();
                            this.items.push(item);
                        }
                        this.items[0].quantity += how_many_items_to_add;
                        this.update_price_of_purchase(params.productOrGroupItem);
                        return true;
                    }
                }
            }
            else {
                console.warn("Quantité à ajouter, non autorisée.\n", "Code : 1043\n", "File : Purchase.ts\n", "Object : Purchase\n", "Function : private add_item()\n");
                console.group("Object en cours");
                console.warn(this);
                console.groupEnd();
            }
        }
        return false;
    };
    Purchase.prototype.get_sum_items = function (status_canceled_uid, canceled) {
        if (canceled === void 0) { canceled = false; }
        var total = 0;
        var totalCanceled = 0;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (!item.isCanceled(status_canceled_uid)) {
                total += item.quantity;
            }
            else {
                totalCanceled += item.quantity;
            }
        }
        if (canceled) {
            return totalCanceled;
        }
        else {
            return total;
        }
    };
    Purchase.prototype.get_sum_child_items = function (status_canceled_uid) {
        var total = 0;
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var child = _a[_i];
            total += child.get_sum_items(status_canceled_uid);
        }
        return total;
    };
    Purchase.prototype.update_price_of_purchase = function (productOrGroupItem) {
        if (productOrGroupItem instanceof Product) {
            this.price = productOrGroupItem.price;
            this.priceWithTax = productOrGroupItem.priceWithTax;
            this.vat = productOrGroupItem.vat;
        }
        else if (productOrGroupItem instanceof GroupItem) {
            this.price = productOrGroupItem.overCost;
            this.priceWithTax = productOrGroupItem.overCostWithTax;
        }
        else {
            return false;
        }
        return true;
    };
    Purchase.getCorrespondingPurchase = function (purchaseUid, purchases) {
        for (var _i = 0, purchases_1 = purchases; _i < purchases_1.length; _i++) {
            var purchase = purchases_1[_i];
            if (purchase.uid === purchaseUid) {
                return purchase;
            }
        }
        return null;
    };
    Purchase.prototype.requireSuppData = function (suppData) {
        for (var _i = 0, _a = this.childPurchases; _i < _a.length; _i++) {
            var purchase = _a[_i];
            if (purchase.requireSuppData(suppData)) {
                return true;
            }
        }
        return (this.productUid && suppData.data.productUids.includes(this.productUid)) || (this.itemUid && suppData.data.itemUids.includes(this.itemUid));
    };
    return Purchase;
}(Model));
export default Purchase;
//# sourceMappingURL=Purchase.js.map